import { defineMessages } from 'react-intl';

export const i18n: {
	noAttachments: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	download: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	version: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	currentVersion: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	dateByUser: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modifiedByUser: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	createdByUser: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	paginationPrev: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	paginationNext: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	inlinePreviewAlt: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	versionHistory: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	labels: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	noLabels: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	editLabels: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	preview: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	view: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	properties: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	deleteAttachment: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	errorGeneric: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	errorPageNotFound: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	errorNoPagePermission: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	downloadAll: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	downloadAllDesc: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	loading: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	columnName: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	expandVersionHistory: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	collapseVersionHistory: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	columnModified: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	columnAuthor: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	columnExpandToggle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noAttachments: {
		id: 'attachments-macro.no-attachments',
		description: 'Message shown when there are no attachments on the page',
		defaultMessage: 'There are currently no attachments on this page.',
	},
	download: {
		id: 'attachments-macro.download',
		description: 'Label for a download link/button',
		defaultMessage: 'Download',
	},
	version: {
		id: 'attachments-macro.version',
		description: 'Prefix label shown before the version number in version history rows',
		defaultMessage: 'Version',
	},
	currentVersion: {
		id: 'attachments-macro.current-version',
		description: 'Badge shown next to the latest version in version history',
		defaultMessage: '(current version)',
	},
	dateByUser: {
		id: 'attachments-macro.date-by-user',
		defaultMessage: '{date} by {userName}',
		description:
			'Date and author name in the Modified column, e.g. "May 13, 2025 by Alice Johnson".',
	},
	modifiedByUser: {
		id: 'attachments-macro.modified-by-user',
		description: 'Label shown before the user name for non-initial versions.',
		defaultMessage: 'Modified by {userName}',
	},
	createdByUser: {
		id: 'attachments-macro.created-by-user',
		description: 'Label shown before the user name for the initial version.',
		defaultMessage: 'Created by {userName}',
	},
	versionHistory: {
		id: 'attachments-macro.version-history',
		description: 'Section heading for the version history sub-table',
		defaultMessage: 'Version history',
	},
	labels: {
		id: 'attachments-macro.labels',
		description: 'Section label for the labels list in an expanded attachment row',
		defaultMessage: 'Labels',
	},
	noLabels: {
		id: 'attachments-macro.no-labels',
		description: 'Text shown when an attachment has no labels',
		defaultMessage: 'No labels',
	},
	editLabels: {
		id: 'attachments-macro.edit-labels',
		description: 'Aria label / tooltip for the pencil icon button to edit attachment labels',
		defaultMessage: 'Edit labels',
	},
	paginationPrev: {
		id: 'attachments-macro.pagination.prev',
		description: 'Label for the previous page button in pagination',
		defaultMessage: 'Prev',
	},
	paginationNext: {
		id: 'attachments-macro.pagination.next',
		description: 'Label for the next page button in pagination',
		defaultMessage: 'Next',
	},
	preview: {
		id: 'attachments-macro.preview',
		description: 'Button label for opening the attachment preview',
		defaultMessage: 'Preview',
	},
	inlinePreviewAlt: {
		id: 'attachments-macro.inline-preview-alt',
		description:
			'Alternative text / title for the inline file preview (image or PDF) shown below an attachment',
		defaultMessage: 'Preview of {fileName}',
	},
	view: {
		id: 'attachments-macro.view',
		description: 'Button label for viewing the attachment',
		defaultMessage: 'View',
	},
	properties: {
		id: 'attachments-macro.properties',
		description: 'Button label for editing attachment properties (filename, comment)',
		defaultMessage: 'Properties',
	},
	deleteAttachment: {
		id: 'attachments-macro.delete',
		description: 'Button label for deleting an attachment',
		defaultMessage: 'Delete',
	},
	errorGeneric: {
		id: 'attachments-macro.error-generic',
		description: 'Generic error message when attachments cannot be retrieved',
		defaultMessage: 'Error retrieving attachments',
	},
	errorPageNotFound: {
		id: 'attachments-macro.error-page-not-found',
		description: 'Error shown when the referenced page cannot be found',
		defaultMessage: 'Item not found: {pageTitle}',
	},
	errorNoPagePermission: {
		id: 'attachments-macro.error-no-page-permission',
		description: 'Error shown when the user lacks view permission on the referenced page',
		defaultMessage: 'Restrictions have been applied that limit access to this content: {pageTitle}',
	},
	downloadAll: {
		id: 'attachments-macro.download-all',
		description: 'Label for the bulk download all attachments link',
		defaultMessage: 'Download All',
	},
	downloadAllDesc: {
		id: 'attachments-macro.download-all-desc',
		description: 'Accessible description for the bulk download all attachments link',
		defaultMessage: 'Download all attachments',
	},
	loading: {
		id: 'attachments-macro.loading',
		description: 'Accessible label for the spinner shown while attachments are loading',
		defaultMessage: 'Loading attachments\u2026',
	},
	columnName: {
		id: 'attachments-macro.column-name',
		description: 'Column header label for the file name column',
		defaultMessage: 'File',
	},
	expandVersionHistory: {
		id: 'attachments-macro.expand-version-history',
		description: 'Screen reader label for the expand button — describes the action',
		defaultMessage: 'Expand version history for {fileName}',
	},
	collapseVersionHistory: {
		id: 'attachments-macro.collapse-version-history',
		description: 'Screen reader label for the collapse button — describes the action',
		defaultMessage: 'Collapse version history for {fileName}',
	},
	columnModified: {
		id: 'attachments-macro.column-modified',
		description: 'Column header label for the last modified date column',
		defaultMessage: 'Modified',
	},
	columnAuthor: {
		id: 'attachments-macro.column-author',
		description: 'Column header label for the last modifier author column',
		defaultMessage: 'Author',
	},
	columnExpandToggle: {
		id: 'attachments-macro.column-expand-toggle',
		defaultMessage: 'Expand attachment details',
		description: 'Screen reader label for the expand toggle column in the attachments table',
	},
});
